import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';
import { getSkillAcquisitionProgramListDetails, updateProgramInstruction } from './actions/skillAquisitionProgramActions';
import { renderTextArea } from '../../../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../img/small-loader.gif';

const validateForm = (values) => {
  const errors = {};

  if (!values.programInstructions) {
    errors.programInstructions = 'Please enter program instruction'
  }
  return errors;
};

class ProgramInstructionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      skillsAcquisitionProgramId: props.skillsAcquisitionProgramId,
    };
  }

  componentWillMount() {    
    if (this.state.skillsAcquisitionProgramId) {
      this.props.getSkillAcquisitionProgramListDetails(this.state.skillsAcquisitionProgramId);
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  onSubmitHandler(formProps) {
    this.props.updateProgramInstruction(this.props.skillsAcquisitionProgramId, formProps.programInstructions);
    this.setState({ open: false });
    this.props.closeDialog();
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <Dialog
        className="custom_modal"
        title='Program Instruction'
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}
      >
        {this.renderLoading()}
        <div className="row">
          <div className="col-sm-12">
            <form
              className="readmin-form custom_form"
              onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}
            >
              <div className="panel-body">
                <div className="row">
                  <div className="col-sm-12">
                    <Field
                      name="programInstructions"
                      type="text"
                      maxLength="1000"
                      label="Program Instructions"
                      // normalize ={isValidNameWithSpace}
                      component={renderTextArea} />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}

ProgramInstructionModal = reduxForm({
  form: 'ProgramInstructionModalForm',
  validate: validateForm,
  enableReinitialize: true,
})(ProgramInstructionModal);


function mapStateToProps(state, ownProps) {
  let initialValueData = {};
  
  if (ownProps.skillsAcquisitionProgramId && state.skillAcquisitionProgram.skillAcquisitionProgramDetail) {
    initialValueData = state.skillAcquisitionProgram.skillAcquisitionProgramDetail.data || null;
  }

  return {
    loading: state.skillAcquisitionProgram.loading,
    initialValues: initialValueData,
  }
}

export default connect(mapStateToProps, {getSkillAcquisitionProgramListDetails, updateProgramInstruction })(ProgramInstructionModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Program/programInstruction_Modal.js